import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";


//IMAGES
import { ReactComponent as InstaIcon } from "../../Assets/Images/Header/Instagram.svg";
import HeroTopVector from "../../Assets/Images/LandingPage/hero_top_vector.svg";



export const AboutIntroContainer = styled.div`
   font-family: 'Outfit', sans-serif;
    .aboutintro_main {
        padding: 100px 0;
        padding-bottom: 0px;
    }
    h4.about-intro_subtxt {
        color: #021E40;
        font-weight:600;
    }
    .about_intro_content strong {
        color: #021E40;
    }
    .video_section_founder .mygrid-row {
        border-top: 1px solid #A1A0A0;
        padding: 70px 0;
        padding-bottom: 0;
        align-items: center;
    }


    @media (max-width: 991px) {
        .aboutintro_main{
         padding-top:70px;
        }
         .video_section_founder .mygrid-row {
            padding-bottom: 0 !important;
        }
    }
    @media (max-width: 767px) {
        .aboutintro_main {
            padding: 50px 0;
            padding-bottom: 0px;
        }
            
    }


  }

`;

